import React from 'react';
import { Box, Button, CardContent, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FilterListIcon from '@mui/icons-material/FilterList';
import dayjs, { Dayjs } from 'dayjs';
import { EnumView } from '../../../../../services/DimensionService/types/dimensionTypes';

interface PMReportFiltersProps {
  centers: EnumView[];
  categories: EnumView[];
  centerId: string;
  category: string;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onCenterChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onFromDateChange: (value: Dayjs | null) => void;
  onToDateChange: (value: Dayjs | null) => void;
  onApply: () => void;
  onReset: () => void;
}

const PMReportFilters: React.FC<PMReportFiltersProps> = ({
  centers,
  categories,
  centerId,
  category,
  fromDate,
  toDate,
  onCenterChange,
  onCategoryChange,
  onFromDateChange,
  onToDateChange,
  onApply,
  onReset,
}) => {
  return (
    <CardContent sx={{ backgroundColor: '#f8fafc' }}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <FilterListIcon sx={{ color: '#64748b', fontSize: 20 }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: '#64748b' }}>
            Filters
          </Typography>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <FormControl size="small" sx={{ flex: 1 }}>
            <InputLabel>Center</InputLabel>
            <Select
              value={centerId}
              label="Center"
              onChange={(e) => onCenterChange(e.target.value)}
            >
              <MenuItem value="">All Centers</MenuItem>
              {centers.map((c) => (
                <MenuItem key={c.value} value={c.value}>{c.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ flex: 1 }}>
            <InputLabel>PM Category</InputLabel>
            <Select
              value={category}
              label="PM Category"
              onChange={(e) => onCategoryChange(e.target.value)}
            >
              <MenuItem value="">All Categories</MenuItem>
              {categories.map((c) => (
                <MenuItem key={c.value} value={c.value}>{c.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <DatePicker
            label="From Date"
            value={fromDate}
            onChange={onFromDateChange}
            slotProps={{ textField: { size: 'small', sx: { flex: 1 } } }}
          />
          <DatePicker
            label="To Date"
            value={toDate}
            onChange={onToDateChange}
            slotProps={{ textField: { size: 'small', sx: { flex: 1 } } }}
          />
        </Stack>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="outlined" size="small" onClick={onReset}>
            Reset
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={onApply}
            sx={{ backgroundColor: '#3b82f6', '&:hover': { backgroundColor: '#2563eb' } }}
          >
            Apply
          </Button>
        </Stack>
      </Stack>
    </CardContent>
  );
};

export default PMReportFilters;
